import React from 'react';
import {Checkbox, SvgIcon} from "@mui/material";

// вспомогательная версия чекбокса: отображает выключенное состояние с белым фоном (а обычный mui-чекбокс использует прозрачный фон)
const CheckboxV2 = ({size, sx, iconFillColor, ...props}) => {
    const newSx = (size === "small" ? { ...sx, '& .MuiSvgIcon-root': { fontSize: 20 } } : sx);
    return (
        <Checkbox {...props} size="medium" sx={newSx} icon={<CheckBoxBlankIcon fillColor={iconFillColor}/>}/>
    );
};

const CheckBoxBlankIcon = ({fillColor}) => (
    <SvgIcon>
        <svg focusable="false">
            <path
                d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5"
                fill={fillColor ? fillColor : "white"}
            ></path>
            <path
                d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                fill="#595B5C"
            ></path>
        </svg>
    </SvgIcon>
);

export default CheckboxV2;